/*
  FIX: O sticky add-to-cart (.m-sticky-addtocart) fica fixo na parte de baixo da tela
  e cobre fisicamente o footer e as seções finais da página (FAQ, testimonials, etc),
  fazendo o usuário clicar sem querer em "Add to cart" / quantidade pensando que está
  tocando no conteúdo visível atrás.

  Este script esconde o sticky bar assim que o footer entra na viewport, e também
  remove o padding-bottom reservado pra ele (--f-sticky-atc-bar-height), que senão
  deixa um espaço em branco extra depois do footer.
*/
(function () {
  function initStickyAtcFooterFix() {
    var stickyBar = document.querySelector('.m-sticky-addtocart');
    var footer = document.querySelector('m-footer, .m-footer');

    if (!stickyBar || !footer) return;
    if (stickyBar.dataset.footerFixAttached) return;
    stickyBar.dataset.footerFixAttached = 'true';

    if (!('IntersectionObserver' in window)) return;

    var footerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Footer visível: força o sticky bar a sair da tela, ignorando o estado do form principal
            stickyBar.style.setProperty('--m-translate-y', '100%');
            stickyBar.style.pointerEvents = 'none';
            // Remove o espaço reservado pro sticky bar, senão sobra padding em branco após o footer
            document.documentElement.style.setProperty('--f-sticky-atc-bar-height', '0px');
          } else {
            // Footer não visível: libera o sticky bar pra voltar ao comportamento normal
            stickyBar.style.pointerEvents = '';
            stickyBar.style.removeProperty('--m-translate-y');
            document.documentElement.style.setProperty('--f-sticky-atc-bar-height', stickyBar.offsetHeight + 'px');
          }
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );

    footerObserver.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtcFooterFix);
  } else {
    initStickyAtcFooterFix();
  }
  window.addEventListener('load', initStickyAtcFooterFix);
})();
